import { Component, ElementRef, ViewChild, OnInit, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertPanelModel } from '../../../../_models/common/alertPanelModel';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../../shared.module';
import { FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'formly-upload-logo',
    templateUrl: "./formly-upload-logo.component.html",
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormlyModule, TranslateModule, SharedModule]
})
export class FormlyUploadLogoComponent extends FieldType implements OnInit, OnDestroy, AfterViewInit {
    fieldKey: string;
    formSubmissionSubscription: Subscription;
    isFormSubmitted: boolean = false;
    imgUrl: string = "";
    alertPanelModel: AlertPanelModel;
    showAlertPanel: boolean = false;
    fileExtensions: string[] = [".png", ".jpg", ".jpeg"];

    constructor(
        private translate: TranslateService,
        private dynamicFormService: DynamicFormService, private cdRef: ChangeDetectorRef) {
        super();
    }

    ngOnInit() {
        if (this.field.key) {
            this.fieldKey = this.field.id ?? this.field.key.toString();
        }
        this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
            this.isFormSubmitted = data;
        });
        this.imgUrl = this.field.templateOptions.defaultLogo;
    }

    ngOnDestroy() {
        if (this.formSubmissionSubscription) {
            this.formSubmissionSubscription.unsubscribe();
        }
    }

    ngAfterViewInit() {
        this.form.valueChanges.subscribe(() => {
            this.cdRef.detectChanges()
        });
    }

    onValueChange(files: any) {
        if (files) {

            if (this.isValidFile(files[0])) {
                let reader = new FileReader();
                reader.readAsDataURL(files[0]);
                reader.onload = (event) => {
                    const img = new Image();
                    img.src = reader.result as string;
                    img.onload = () => {
                        const height = img.naturalHeight;
                        const width = img.naturalWidth;
                        if (height <= 50 && width <= 160) {
                            this.imgUrl = reader.result.toString();
                            this.formControl.setValue(this.imgUrl);
                            this.to.change(this.field, files[0]);
                        } else {
                            this.showAlertPanel = true;
                            this.alertPanelModel = new AlertPanelModel(
                                true,
                                this.translate.instant("label_alert"),
                                [],
                                '',
                                this.translate.instant("Close"),
                                true,
                                this.translate.instant("logo_resize_validation")
                            );
                            this.formControl.setValue(null);
                            this.to.change(this.field, files[0]);
                            this.cdRef.detectChanges();
                            return;
                        }
                    };
                };
            } else {
                this.formControl.setValue(null);
                this.to.change(this.field, files[0]);
            }

        }
    }

    getSupportedExtensionsText() {
        let text = "";
        if (this.fileExtensions) {
            text = this.fileExtensions.join(' / ');
        }
        return text;
    }

    isValidFile(file: any) {
        let isValid = true;
        if (!this.checkExtension(file.name)) {
            this.showAlertPanel = true;
            this.alertPanelModel = new AlertPanelModel(
                true,
                this.translate.instant("label_alert"),
                [
                    this.translate.instant("Please_upload_the_images_only") + ' <span class="text-uppercase font-weight-bold">' + this.getSupportedExtensionsText() + '</span>'
                ],
                '',
                this.translate.instant("Close"),
                true,
                this.translate.instant("invalid_image_format")
            );
            isValid = false;
            this.cdRef.detectChanges();
            return isValid;
        }

        let mimeType = file.type;

        if (mimeType.match(/image\/*/) == null) {
            this.showAlertPanel = true;
            this.alertPanelModel = new AlertPanelModel(
                true,
                this.translate.instant("label_alert"),
                [this.translate.instant("Please_upload_the_images_only"),
                this.translate.instant("only_images_are_supported")
                ],
                '',
                this.translate.instant("Close"),
                true
                , this.translate.instant("only_images_are_supported")
            );
            isValid = false;
            this.cdRef.detectChanges();
            return isValid;
        }

        if (file.size > 200000) {
            this.showAlertPanel = true;
            this.alertPanelModel = new AlertPanelModel(
                true,
                this.translate.instant("label_alert"),
                [],
                '',
                this.translate.instant("Close"),
                true,
                this.translate.instant("file_size_exceeded")
            );
            isValid = false;
            this.cdRef.detectChanges();
            return isValid;
        }
        return isValid;
    }

    checkExtension(fileName: any) {
        return this.fileExtensions.some(el => fileName.toLowerCase().endsWith(el));
    }

    alertPanelReceiver(returnValue: any) {
        this.showAlertPanel = false;
        this.alertPanelModel = null;
        this.cdRef.detectChanges();
    }

}
